import * as React from 'react';
import { Typography, Button, Skeleton } from '@mui/material';
import { useSubscriptionStore } from '../../store/subscription-store';
import { SubscriptionEvents } from '../../events';
import { Subscription } from '@/shared/i18n';
import { EventBus } from '@/shared/utils';
import { CustomerSubscription } from '../../types';

interface SubscriptionCardProps {
  eventBus: EventBus<SubscriptionEvents>;
  dict: Subscription;
}

function getSubscriptionState(subscription: CustomerSubscription | null): string {
  if (!subscription) return 'Non Attivo';
  const { subscriptionStatus, subscriber } = subscription;

  if (subscriber) {
    if (subscriptionStatus?.name === 'pending_cancellation') {
      return 'In cancellazione';
    }
    return 'Attivo';
  }
  return 'Non Attivo';
}

const SubscriptionCard: React.FC<SubscriptionCardProps> = ({ eventBus, dict }) => {
  const subscriptionPlan = useSubscriptionStore(
    (state) => state.customerSubscription?.subscriptionPlan,
  );
  const toggleModal = useSubscriptionStore((state) => state.toggleOpenSubscriptionModal);

  const customerSubscription = useSubscriptionStore((state) => state.customerSubscription);

  const loading = useSubscriptionStore((state) => state.subscriptionsLoading);

  if (loading)
    return (
      <div className="space-y-6">
        <Skeleton animation="wave" variant="rounded" height={370} className="rounded-xl" />
      </div>
    );
  return (
    <>
      {/* Only for Subscribers */}
      {subscriptionPlan && (
        <div className="rounded-xl p-6 bg-background lg:flex w-full justify-between items-center space-y-4">
          <div className="space-y-2">
            <Typography variant="s1" component="p" color="textSecondary">
              {subscriptionPlan?.title}
            </Typography>
            <Typography variant="body-500">
              Stato: {getSubscriptionState(customerSubscription)}
            </Typography>
          </div>
          <Button variant="outlined" color="primary" size="medium" onClick={toggleModal}>
            <Typography variant="button-m" style={{ textTransform: 'capitalize' }}>
              {dict.subscriptions.change_subscription_plan}
            </Typography>
          </Button>
        </div>
      )}

      {/* for NOT Subscribers */}
      {!subscriptionPlan && (
        <div className="md:p-8 w-full flex flex-col-reverse md:flex-row flex-wrap md:flex-nowrap justify-between gap-x-6 gap-y-6">
          <div className="flex flex-col justify-center gap-y-6">
            <Typography variant="h2">{dict.subscriptions.no_active_subscriptions}</Typography>
            <Button
              variant="contained"
              color="primary"
              size="large"
              className="mr-auto"
              onClick={toggleModal}
            >
              <Typography variant="button-l">{dict.subscriptions.buy_subscription}</Typography>
            </Button>
          </div>
          <div>
            <img
              src="/assets/images/profile/nessun-abbonamento-placeholder.png"
              className="w-[355px] h-auto"
              alt="Nessun abbonamento attivo"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default SubscriptionCard;
